export default __webpack_public_path__ + "static/error-ad0668be36d878ea3256c7816a141336.jpg";